module.exports = __webpack_public_path__ + "img/img79.48e79880.svg";